module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki18_sp-0da0b8bdc714577ef9ae0c4e0f56eac4.jpg";